module.exports = __webpack_public_path__ + "static/media/small-hero-ehs.37c8207f.png";